import * as React from "react";

const NewChatIcon = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 22 22"
        {...props}
    >
        <path d="M17.618,1.461a.276.276,0,0,1,.394-.009l.009.009,2.516,2.515a.275.275,0,0,1,.009.394l-.009.009L18.989,5.926,16.07,3.009Zm3.888,3.893L19.483,7.376l-.008.008-.008.008-7,7a.688.688,0,0,1-.486.2H8.37l-.775.774a.687.687,0,0,1-.972-.972l.775-.774v-3.6a.687.687,0,0,1,.2-.486L16.646.49A1.651,1.651,0,0,1,19,.494L21.51,3A1.649,1.649,0,0,1,21.506,5.354ZM15.1,3.981,18.016,6.9l-6.325,6.321H8.772V10.3ZM1.375,4.122A1.361,1.361,0,0,1,2.64,2.748h7.8a.687.687,0,1,0,0-1.374H2.64A2.734,2.734,0,0,0,0,4.122V19.362A2.638,2.638,0,0,0,2.64,22H18.219a2.448,2.448,0,0,0,2.406-2.638V11.57a.688.688,0,0,0-1.375,0v7.791c0,.7-.328,1.264-1.031,1.264H2.64a1.263,1.263,0,0,1-1.265-1.264Z" />
    </svg>
)

export default NewChatIcon;
